import SummarizeIcon from '@mui/icons-material/Summarize';
import { Avatar, Box, Grid, IconButton, Typography, Divider } from "@mui/material";
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import KPeeLogo from '../LogoKPee1.png';
import { api } from '../api';
import AuthContext from "../auth/AuthProvider";
import { fetchToken } from '../auth/Token';
import { useMode } from "../theme";

export const ApplicationForm = () => {
    const [theme, colorMode] = useMode();
    const [isSidebar, setIsSidebar] = useState(true);
    const location = useLocation();
    const association_id = location.state && location.state.association_id;
    const {  permissions } = useContext(AuthContext);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [members, setMembers] = useState([])
    const [details, setDetails] = useState([])
    const [leaders, setLeaders] = useState([])

    const fetchLeaders = () => {
        api.get(`/association/get/association/leaders/${association_id}`, {
          headers: {
              Authorization: 'Bearer '+fetchToken()
          },
        }).then(function (response){
          setLeaders(response.data)
        }).catch(function (error){
          console.log(error)
        });
    }

    const fetchData = () => {
        api.get(`/association/association/application/forms/print/${association_id}`, {
          headers: {
              Authorization: 'Bearer '+fetchToken()
          },
        }).then(function (response){
            setMembers(response.data?.members)
            setDetails(response.data?.details)
        }).catch(function (error){
          console.log(error)
        });
    }

    useEffect(() => {
        fetchData();
        fetchLeaders();
    },[])


  

    const printRef = React.useRef();

    const handlePrint = async () => {
        const element = printRef.current;
        const canvas = await html2canvas(element);
        const data = canvas.toDataURL('image/png');
    
        const pdf = new jsPDF();
        const imgProperties = pdf.getImageProperties(data);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;
    
        const pageHeight = pdf.internal.pageSize.getHeight();
        const marginLeft = 10;
        const marginTop = 10;
        const marginRight = 10;
        const marginBottom = 10;
        let yOffset = 0;
        let pageNumber = 1;
    
        while (yOffset < pdfHeight) {
            if (pageNumber > 1) {
                pdf.addPage();
            }
    
            pdf.addImage(
                data,
                'PNG',
                marginLeft,
                marginTop - yOffset,
                pdfWidth - marginLeft - marginRight,
                pdfHeight - marginTop - marginBottom
            );
    
            // Add page label
            pdf.setFontSize(8);  // Make the font size smaller
        pdf.text(`Page ${pageNumber}`, marginLeft - 9, pageHeight - marginBottom + 5);
    
            yOffset += pageHeight - marginTop - marginBottom;
            pageNumber++;
        }
    
        pdf.save('Loan Request Form.pdf');
    };

  return (
      <div className="app">
        <main className="content">
            <Box>
                <Box sx={{ display:'flex', m:2 }}>
                        <Typography sx={{ ml:'5px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Print:</b>
                            <IconButton onClick={handlePrint}><SummarizeIcon size='small'/></IconButton>
                        </Typography>
                    </Box>
                    <div ref={printRef} style={{ display:'block', marginBottom:5 }}>
                        <Box sx={{ m:1 }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={12}>
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign:'center', color:'grey',mb:3 }}><b>~ The Cooperative ~</b></Typography>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Avatar src={KPeeLogo} alt='KPee logo' sx={{ width:120, height:120, m:'auto' }} />
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Typography variant='h3' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign:'center' }}><b>{details.society}</b></Typography>
                                    <Typography variant='h4' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign:'center' }}><b>{details.community_name} Community</b></Typography>
                                    <Typography variant='h5' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign:'center' }}><b>{details.cluster_name} Cluster</b></Typography>
                                    <Typography variant='h6' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign:'center' }}><b>{details.association_name} Savings Group</b></Typography>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Typography variant='h4' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign:'center' }}><b>Loan Request Form</b></Typography>
                                </Grid>

                                <Grid item xs={12} md={12}>
                                    <Box sx={{ml:3, mr:3}}>
                                    <Typography variant='body1' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ whiteSpace: 'pre-line', mt: 2, textAlign:'justify' }}>
                                            <b>{`I, __________________________________________ (Member Name), a member of the ${details.association_name} Savings Group, 
                                            hereby request a loan in the amount of GHC __________________________. This loan is being requested for the purpose of __________________________________________ (Project/Business Purpose). 
                                            I confirm that all details provided are accurate and that I fully understand the terms and conditions associated with this loan. I acknowledge that I am individually, as well as jointly and severally, responsible for the repayment of the full loan amount.

                                        I further certify that I have received a full explanation of the loan conditions, and I agree to abide by the policies of the Society regarding loan disbursement and repayment.

                                        Date: ________________________
                                        `}</b>
                                    </Typography>
                                    </Box>
                                </Grid>

                                {
                            leaders.map((leader) => (
                                <Grid item xs={12} md={4}>
                                    <Divider sx={{ m:2, mt:5 }} />
                                    <Box>
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{leader?.position} ({leader?.name})</b></Typography>
                                    </Box>
                                </Grid>
                            ))
                        }
                        <Grid item xs={12} md={4}>
                            <Divider sx={{ m:2, mt:5 }}/>
                            <Box>
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Sign</b></Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={4} sx={{ mb:20, mt:5 }}>
                            <Divider />
                            <Box>
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Sign</b></Typography>
                            </Box>
                        </Grid>
                                
                            </Grid>

                        </Box>
                    </div>
                </Box>
                </main>
      </div>
  )
}

export default ApplicationForm;